'use strict';
(function (window, document, $) {
    var $registrationForm,
        $registrationErrorMessage,
        $registrationButton,
        $registrationButtonText,
        $registrationSpinner,
        $urlParameters = window.jwsdwUtil.urlUtils.getAllQueryParameters($(location).attr('href').split('?')[1] || ''),
        $loyaltyRegistrationSection = $('#jwsdw-loyaltyRegistrationForm'),
        xhr;

    $.validator.setDefaults({
        'rules': {
            'email': {
                'invalidvalue': true,
                'customemail': true
            },
            'dateOfBirth': {
                'checkDate': '#jwsdw-register-dateOfBirth',
                'isAdult': '#jwsdw-register-dateOfBirth'
            }
        }
    });

    if ($loyaltyRegistrationSection.length) {
        fetchLoyaltyRegistrationForm();
    }

    /**
     * Fetches loyalty benefits data from the server
     * @returns {void}
    */
    function fetchLoyaltyRegistrationForm() {
        const queryString = window.location.search.substring(0);
        const url = window.jwsdwSettings.baseUrl + '/Loyalty-showLoyaltyRegistration' + queryString;
        const method = 'GET';

        $.ajax({
            'url': url,
            'method': method,
            'success': (data) => {
                handleSuccess(data);
            },
            'error': (data) => {
                handleError(data);
            }
        });
    }

    /**
     * Handles successful response from the server
     * @param {string} data - HTML content returned by the showLoyaltyRegistration endpoint
     * @returns {void}
    */
    function handleSuccess(data) {
        $loyaltyRegistrationSection.append(data);
        $registrationForm = $('form.jwsdw-loyalty-register-form');
        $registrationErrorMessage = $('.jwsdw-loyaltyRegistration-error');
        $registrationButton = $registrationForm.find('.jwsdw-accordionForm-listItem-submit');
        $registrationButtonText = $registrationButton.find('.jwsdw-buttonText');

        $('input[name="source"]').attr('value', $urlParameters.source || $urlParameters.utm_source || "");

        // initialize form validation
        $registrationForm.validate();

        $registrationSpinner = $registrationButton.find('.jwsdw-spinner');

        window.jwsdwMediator.publish('dateInput:init', '#jwsdw-register-dateOfBirth');
    }

    /**
     * Handles error response from the showLoyaltyRegistration endpoint
     * @param {Object} error - Error object
     * @returns {void}
    */
    function handleError(error) {
        window.console.error('Failed to load loyalty registration form:', error);
    }

    /**
     * Method to handle form submits
     * @param {Object} e the event that triggered the handler
     * @param {function} successCallback the callback that is triggered when the ajax call was successful
     * @param {function} errorCallback the callback that is triggered when the ajax call was unsuccessful
     * @param {function} beforeSendCallback the callback that is triggered before the ajax call is made
     * @param {String} action the name of the action to be executed
     * @returns {void}
     */
    function loyaltyFormSubmit (e, successCallback, errorCallback, beforeSendCallback, action) {
        const $this = $(this),
            $captcha = $this.find('.g-recaptcha');

        e.preventDefault();

        // only submit form if frontend validation is successful and no other call is executed
        if (!$this.valid() || (xhr && xhr.readyState !== 4)) {
            return;
        }

        if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
            window.grecaptcha.ready(function() {
                window.jwsdwUtil.captcha.execute($captcha.attr('id'), action).then(submitFormHandler);
            });
        } else {
            submitFormHandler();
        }

        /**
         * @function
         * @description Handler to trigger submit again when form is valid
         * @return {void}
         */
        function submitFormHandler() {
            // XHR request to form action url with form fields as parameters
            xhr = $.ajax($this.attr('action'), {
                'method': $this.attr('method') || 'GET',
                'data': $this.serialize(),
                'beforeSend': beforeSendCallback,
                'success': successCallback,
                'error': errorCallback
            });
        }
    }

    /**
     * Method to execute if registration was handled successfully
     * @param {object} data the data returned by the server
     * @param {String} [data.redirectUrl] the data returned by the server
     * @returns {void}
     */
    function loyaltyRegistrationSuccessCallback (data) {
        if (typeof data.redirectUrl === 'string') {
            window.location.href = data.redirectUrl;
            return;
        }

        $registrationButton.removeAttr('disabled');
        $registrationButtonText.removeClass('jwsdw-invisible');
        $registrationSpinner.addClass('jws-hidden');
        $('.jwsdw-loyaltyRegistration-successMessage').removeClass('jws-hidden');

        window.scrollTo({
            top: $('.jwsdw-loyaltyRegistration-successMessage')[0].getBoundingClientRect().top + window.pageYOffset - $('nav.jwsdw-header-mainMenu').innerHeight(),
            behavior: 'smooth'
        });

        $('.jwsdw-loyaltyRegistration-container').addClass('jws-hidden');

        window.dataLayer.push({
            'event': 'login_success',
            'eventValue':undefined,
            'nonInteraction':false
        });
    }

    /**
     * Method to execute if registration was not handled successfully
     * @param {object} data the response object containing the error
     * @returns {void}
     */
    function loyaltyRegistrationErrorCallback (data) {
        var $errorTextContainer;
        // jquery ajax returns a wrapped result
        data = data.hasOwnProperty('responseJSON') ? data.responseJSON : {};

        if (data.code) {
            $errorTextContainer = $registrationErrorMessage.find('.jws-notificationMessage');
            $errorTextContainer.text(data.details.message);
            $registrationErrorMessage.removeClass('jws-hidden');

            window.scrollTo({
                top: $('.jwsdw-loyaltyRegistration-error')[0].getBoundingClientRect().top + window.pageYOffset - $('nav.jwsdw-header-mainMenu').innerHeight(),
                behavior: 'smooth'
            });
        }

        $registrationButton.removeAttr('disabled');
        $registrationButtonText.removeClass('jwsdw-invisible');
        $registrationSpinner.addClass('jws-hidden');
    }

    /**
     * Method to execute the before send logic before the ajax call is made
     * @returns {void}
     */
    function loyaltyRegistrationBeforeSendCallback () {
        $registrationErrorMessage.addClass('jws-hidden');
        $registrationButton.attr('disabled', 'disabled');
        $registrationButtonText.addClass('jwsdw-invisible');
        $registrationSpinner.removeClass('jws-hidden');
    }

    // registration form submit listener
    $(document).on('submit', 'form.jwsdw-loyalty-register-form', function (e) {
        loyaltyFormSubmit.call(this, e,
            loyaltyRegistrationSuccessCallback,
            loyaltyRegistrationErrorCallback,
            loyaltyRegistrationBeforeSendCallback,
            'loyaltyRegister');
    });

    // listen to mediator event when user selects a store in picker and write data of selected store back to form
    window.jwsdwMediator.subscribe('storePickerSelectStore', function(data) {
        var store = data.store;

        // fill hidden fields data of selected store
        $('#jwsdw-register-jwStore-storeId').val(store.id);
    });
}(window, document, jQuery));
